import { getLineLayerConfig, getPointCircleLayerConfig, LINE_LAYER_SIZE } from "@l2r-front/l2r-map"
import { selectLayerColorOpacity } from "@l2r-front/l2r-utils"

export const damagesLegend = [
    {
        value: 1,
        color: "grades/A",
        labelKey: "containers.damagesLayer.legend.scale.fair",
    },
    {
        value: 10,
        color: "grades/B/secondary",
        labelKey: "containers.damagesLayer.legend.scale.good",
    },
    {
        value: 20,
        color: "grades/C",
        labelKey: "containers.damagesLayer.legend.scale.poor",
    },
    {
        value: 30,
        color: "grades/D",
        labelKey: "containers.damagesLayer.legend.scale.serious",
    },
    {
        value: null,
        color: "grades/E",
        labelKey: "containers.damagesLayer.legend.scale.noScale",
    },
]

export const getDamagesLegendConfig = (t, theme) => {
    return damagesLegend.map(legendItem => {
        return {
            color: theme.palette[legendItem.color]?.main,
            label: t(legendItem.labelKey),
        }
    })
}

export const damagesLayerColorConfig = (currentDisplayedDamageType, theme, selectedRoad = null) => {
    const legendStyles = damagesLegend.flatMap((legendItem) => {
        const color = theme.palette[legendItem.color].main
        return [
            ["==", ["get", "severity"], legendItem.value],
            selectLayerColorOpacity(color, 0.5, selectedRoad),
        ]
    })
    const firstColor = theme.palette[damagesLegend[0].color].main
    const lastColor = theme.palette[damagesLegend[damagesLegend.length - 1].color].main
    legendStyles.push(firstColor)

    return [
        "case",
        ["!=", ["get", "damageType"], `${currentDisplayedDamageType}`],
        "transparent",
        ["==", ["typeof", ["get", "severity"]], "null"],
        selectLayerColorOpacity(lastColor, 0.5, selectedRoad),
    ].concat(legendStyles)
}

export const getDamagesLineLayerStyle = (currentDisplayedDamageType, theme, selectedRoad = null) => {
    return getLineLayerConfig({
        "paint": {
            "line-color": damagesLayerColorConfig(currentDisplayedDamageType, theme, selectedRoad),
            "line-width": LINE_LAYER_SIZE,
        },
    })
}

export const getDamagesPointLayerStyle = (currentDisplayedDamageType, theme, selectedRoad = null) => {
    return getPointCircleLayerConfig({
        "paint": {
            "circle-color": damagesLayerColorConfig(currentDisplayedDamageType, theme, selectedRoad),
            "circle-radius": LINE_LAYER_SIZE,
        },
    })
}
